export interface Barrel {
	Id: number | null;
	Name: string;
	DwgFileName: string;
	StandId: number | null;
	StandName: string | null;
	BottomDiameter: number;
	BottomDiameterScrap: number;
	BottomRollMaterialId: number | null;
	BottomRollMaterialName: string | null;
	TopDiameter: number;
	TopDiameterScrap: number;
	TopRollMaterialId: number | null;
	TopRollMaterialName: string | null;
	Comments: string;
	PitProgramName: string | null;
	Active: boolean;
}

export const BARREL_INITIAL_VALUES: Barrel = {
	Id: null,
	Name: "",
	DwgFileName: "",
	StandId: null,
	StandName: null,
	BottomDiameter: 0,
	BottomDiameterScrap: 0,
	BottomRollMaterialId: null,
	BottomRollMaterialName: null,
	TopDiameter: 0,
	TopDiameterScrap: 0,
	TopRollMaterialId: null,
	TopRollMaterialName: null,
	Comments: "",
	PitProgramName: null,
	Active: true,
};

export interface BarrelAttachment {
	BarrelAttachmentId: number;
	BarrelId: number;
	UploadFileId: number;
	AttachmentName: string;
	AttachmentURL: string;
	CreationTime: Date;
	CreatedBy: string;
	URL: string;
}

export interface BarrelLayout {
	Id: number;
	BarrelId: number;
	PassId: number;
	PassName: string;
	PassTypeId: number | null;
	PassTypeName: string | null;
	PassShapeId: number | null;
	PassShapeName: string | null;
	PassScheduledTonnage: number | null;
	Position: number;
}

export interface Stand {
	Id: number;
	Name: string;
	Number: number | null;
	MillSizeId: number | null;
	MillSizeName: string | null;
	Active: boolean;
}

export interface RollMaterial {
	Id: number;
	Name: string;
	Active: boolean;
}

export interface PassId {
	Id: number;
	Name: string;
	StandId: number | null;
	StandName: string | null;
	PassTypeId: number | null;
	PassTypeName: string | null;
	PassShapeId: number | null;
	PassShapeName: string | null;
	ScheduledTonnage: number | null;
	Active: boolean;
	Description: string | null;
}
